import { TranslationRepository } from '../data/translation-repository';
import { TranslationVersion } from '../types/translation-types';

export class GetVersionContentUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  /**
   * Fetches version detail including jsonSnapshot (the translation JSON content)
   */
  async execute(versionId: number): Promise<TranslationVersion> {
    return this.repository.getVersionById(versionId);
  }
}
